import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

interface DigitalClockProps {
  timezone?: string;
}

export function DigitalClock({ timezone = 'Europe/Rome' }: DigitalClockProps) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatter = new Intl.DateTimeFormat('it-IT', {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });

  const parts = formatter.formatToParts(time);
  const weekday = parts.find(p => p.type === 'weekday')?.value;
  const day = parts.find(p => p.type === 'day')?.value;
  const month = parts.find(p => p.type === 'month')?.value;
  const year = parts.find(p => p.type === 'year')?.value;
  const hour = parts.find(p => p.type === 'hour')?.value;
  const minute = parts.find(p => p.type === 'minute')?.value;
  const second = parts.find(p => p.type === 'second')?.value;

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
      <Clock className="h-4 w-4 text-gray-500" />
      <div className="flex flex-col">
        <span className="text-sm font-mono font-semibold text-gray-900">
          {hour}:{minute}:{second}
        </span>
        <span className="text-xs text-gray-500">
          {weekday}, {day} {month} {year}
        </span>
      </div>
    </div>
  );
}














